import { combineReducers } from "redux";

import contactus from "../features/admin/contactuss/contactus/Slice";

import common from "../features/admin/common/Slice";

const contactuss = combineReducers({
  contactus,
  common,
});

export default contactuss;
